import React, { useEffect, useRef, useState } from "react";
import { width, height } from "../../../CustomComponents/Card/CardStyles";
import { useTranslation } from "react-i18next";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import right_dropdown_arrow from "../../../../assets/images/right_dropdown_arrow.png";
import CustomTextInput from "../../../CustomComponents/CustomtextInput";
import Loader from "../../../CustomComponents/Loader";
import Modal from "../../../CustomComponents/Modal";
import {
  GetApiHeadersWithBearer,
  GetRequest,
  PostRequest,
} from "../../../../network/NetworkUtils";
import { useNavigate, Link } from "react-router-dom";
import {
  fetchConfigarationData,
  retrieveData,
} from "../../../../helpers/utils/Utils";
import CustomAlertModel from "../../../CustomComponents/CustomAlertModel";
import { withOidcSecure } from "@axa-fr/react-oidc";
import Footer from "../../../Layout/Footer";
import HomeLayout from "../../../Layout/HomeLayout";
import HomeHeader from "../../../CustomComponents/HomeHeader";
import { useKeyDown } from "../../../../hooks/useKeyDown";
import statement_page from "../../../../assets/images/statement_page.png";
import shredding_statement from "../../../../assets/images/shredding_statement.png";
import Bell from "../../../../assets/images/Bell.png";
import arrow from "../../../../assets/images/Caret_S.png";

import LeftBar from "../../../CustomComponents/DynamicComponent/LeftBar";
import blue_drop_down from "../../../../assets/images/blue_dropdown_arrow.png";
import HtmlDropDown from "../../../CustomComponents/HtmlDropDown";
import {
  AGREEMENTS,
  STATUS_SUCCESS_CODE,
} from "../../../../network/URLConstants";
import HtmlNavigation from "../../../CustomComponents/HtmlNavigation";
import Agreements from "../../../CustomComponents/Agreements";
import DynamicCard from "../../../CustomComponents/DynamicCard";
import Arrow from "../../../../assets/images/arrow.png";
import logFirebaseEvents from "../../../LogFirebaseEvents";
import { useParams } from "react-router-dom";
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';

const appConfigData = await fetchConfigarationData();

const SMIAgreementCard = ({ transactionDatas, onViewAllClick, viewAll }) => {
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_smione_policies'));

  const dispatch = useDispatch();
  const userId = useSelector((state) => state.userId);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [showModel, setShowModel] = useState(false);
  const HighlightMsgStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
  const HeaderMsgStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles =
    "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const [modelImage, setModelImage] = useState("");
  const [highlightMsg, setHighlightMsg] = useState("");
  const [headerMsg, setheaderMsg] = useState("");
  const [subHeaderMsg, setSubHeaderMsg] = useState("");
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [btn1Text, setBtn1Text] = useState(false);
  const [btn2Text, setBtn2Text] = useState("");
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [type, setType] = useState("");
  const [footerMsg, setFooterMsg] = useState("");
  const [displayContent, setDisplayContent] = useState({});
  const [accountType, setAccountType] = useState({});
  const [toNavigate, setToNavigate] = useState("");
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const [agreementType, setAgreementType] = useState(
    useSelector((state) => state?.documentAgreementType)
  );
  const params = useParams();

  const cardKey = cards?.find(card => card.AccountTypeBit63 === 1)?.CardKey;
  const hasKudzuCard = useSelector((state) => state.hasKudzuCard);
  const agreementTypes = [
    {
      name: "Cardholder Agreement",
      url: "TnC",
      accType: 1,
      CardKey: cardKey,
    },
    {
      name: "E-Sign Agreement",
      url: "Esign",
      accType: 1,
      CardKey: cardKey,
    },
    {
      name: "Terms of Use",
      url: "CustomerTerms",
      accType: 1,
      CardKey: cardKey,
    },
    {
      name: "Privacy Policy",
      url: "PrivacyPolicyV2",
      accType: 1,
      CardKey: cardKey,
    },
    {
      name: "Fee Schedule",
      url: "about_us",
      accType: 1,
      CardKey: cardKey,
    },
  ];

  useKeyDown(() => {}, ["Enter"]);

  const showAlertModal = (
    showModel,
    highlightMsg,
    headerMsg,
    subHeaderMsg,
    btn1Exists,
    btn2Exists,
    btn1Text,
    btn2Text,
    btn1TypeAcpt,
    modelImage,
    showErrorImg,
    isBorderNone
  ) => {
    setshowErrorImg(showErrorImg);
    setisBorderNone(isBorderNone);
    setShowModel(showModel);
    setHighlightMsg(highlightMsg);
    setheaderMsg(headerMsg);
    setSubHeaderMsg(subHeaderMsg);
    setBtn1Exists(btn1Exists);
    setBtn2Exists(btn2Exists);
    setBtn1Text(btn1Text);
    setBtn2Text(btn2Text);
    setBtn1TypeAcpt(btn1TypeAcpt);
    setModelImage(modelImage);
  };
  const linkClickAction = (link) => {
    if (link.link) {
      setToNavigate(link.link);
      showAlertModal(
        true,
        t("heads_up"),
        t("about_to_leave_kudzu"),
        t("redirected_from_kudzu"),
        true,
        true,
        t("continue"),
        t("cancel"),
        true,
        "",
        false,
        false
      );
    }
  };
  const closeCustomAlertModal = () => {
    setShowModel(false);
  };
  const onAcptBtnClick = async () => {
    if (headerMsg == t("about_to_leave_kudzu")) {
      window.open(toNavigate, "_blank");
      closeCustomAlertModal();
      setToNavigate("");
    }
  };
  const onCancelBtnClick = () => {
    if (headerMsg == t("about_to_leave_kudzu")) {
      closeCustomAlertModal();
      setToNavigate("");
    }
  };

  const redirectToPolicy = (policyName) => {
    
    if(policyName === "about_us"){
      window.open("https://www.smionecard.com", "_blank");
      return;
    }
    const selectedAgreementType = agreementTypes.find(agreement => agreement.url === policyName);
    setAgreementType(selectedAgreementType);
    navigate(`/Documents/smiONE/Policies/${selectedAgreementType.name}`);
  };

  const leftBarComp = () => {
    return (
      <>
        <div className="lg:w-[260px] md:w-[183px] sm:w-[164px] w-full sm:mx-0 ml-[2.5rem]">
          <p
            className="text-white font-normal
                    lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px]
                    sm:leading-[30px] leading-[31px]
          font-serif-pro sm:border-b-[2.5px] sm:border-[#4B70B9] lg:pb-14 md:pb-[50px]  sm:border-opacity-[50%]
          sm:pb-[2.6rem] pb-[2.6rem] mb-10"
          >
            {t("easily_access_policy")}
          </p>
          <div className="flex flex-col gap-4 text-white w-[80%]">
            {/* smiONE Navigation */}
            <Link
              to="/Documents/smiONE"
              className="text-white font-bold text-[16px] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
            >
              {"smiONE"}
            </Link>
            <div className="flex flex-col gap-2 ml-5 transition-all duration-300 ease-in-out">
              {/* Statements */}
              {cards?.[0]?.EnableStatements && (
                <Link
                  to="/Documents/smiONE/Statements"
                  className="pb-2 cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                  onClick={() => {
                    logFirebaseEvents(
                      "Documents",
                      "Statement_Clicked",
                      "Statement_Clicked",
                      "",
                      ""
                    );
                  }}
                >
                  <p className="font-hanken-grotesk font-semibold text-[15px] text-[#FEFAEE]">
                    {t("statements")}
                  </p>
                </Link>
              )}

              {/* Policies Dropdown */}
              <div className="flex flex-col gap-6">
                <Link
                  to="/Documents/smiONE/Policies"
                  className="font-hanken-grotesk font-semibold text-[15px] text-[#FEFAEE] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                >
                  {t("privacy_and_legal")}
                </Link>
                <div className="flex flex-col gap-6 ml-5">
                  <button
                    type="button"
                    className={`font-hanken-grotesk font-semibold text-[15px] cursor-pointer bg-transparent border-0 p-0 text-left ${agreementType.url === "TnC" ? "text-[#94C3E8]" : "text-white"}`}
                    onClick={() => redirectToPolicy("TnC")}
                  >
                    {t("card_holder_aggrement")}
                  </button>
                  <button
                    type="button"
                    className={`font-hanken-grotesk font-semibold text-[15px] cursor-pointer bg-transparent border-0 p-0 text-left ${agreementType.url === "PrivacyPolicyV2" ? "text-[#94C3E8]" : "text-white"}`}
                    onClick={() => redirectToPolicy("PrivacyPolicyV2")}
                  >
                    {t("Privacy_policy")}
                  </button>
                  <button
                    type="button"
                    className={`font-hanken-grotesk font-semibold text-[15px] cursor-pointer bg-transparent border-0 p-0 text-left ${agreementType.url === "CustomerTerms" ? "text-[#94C3E8]" : "text-white"}`}
                    onClick={() => redirectToPolicy("CustomerTerms")}
                  >
                    {t("terms_of_use")}
                  </button>
                  <button
                    type="button"
                    className={`font-hanken-grotesk font-semibold text-[15px] cursor-pointer bg-transparent border-0 p-0 text-left ${agreementType.url === "Esign" ? "text-[#94C3E8]" : "text-white"}`}
                    onClick={() => redirectToPolicy("Esign")}
                  >
                    {t("sign_aggrement")}
                  </button>
                  <Link
                    to="/Documents/smiONE/Policies/Fees"
                    className="text-white font-hanken-grotesk font-semibold text-[15px] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
                  >
                    {t("Fees")}
                  </Link>
                  {/* Need string for this */}
                  <button
                    type="button"
                    className={`font-hanken-grotesk font-semibold text-[15px] cursor-pointer bg-transparent border-0 p-0 text-left ${agreementType.url === "about_us" ? "text-[#94C3E8]" : "text-white"}`}
                    onClick={() => redirectToPolicy("about_us")}
                  >
                    {t("about_us")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {hasKudzuCard && 
           <div className="flex flex-col pt-4 gap-10 text-white w-[80%]">
            {/* Kudzu Navigation */}
            <Link
              to="/Documents/Kudzu"
              className="text-white font-bold text-[16px] cursor-pointer hover:opacity-80 active:opacity-80 transition-opacity"
            >
              {"Kudzu"}
            </Link>
          </div>
          }
        </div>
      </>
    );
  };

  return (
    <>
      <HomeLayout>
        <LeftBar
          leftBarType="component"
          isPrimary={true}
          leftBarComp={leftBarComp()}
        />
        <div className="md:w-[150px] sm:w-[70px] w-[0px]"></div>

        <div className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight ">
          <DynamicCard
            cardWidth={width.allpolicies}
            // header={false}
            header={true}
            footer={false}
            // headerContent={headerContent()}
            footerContent={() => {}}
            CardRadius={true}
            HeaderRadius={true}
            isWhite={true}
            isIFrame={true}
          >
            <div className="w-full pb-16">
              <Agreements
                type={agreementType}
                linkClickAction={linkClickAction}
                isFromEsignAccept={false}
                isBorderRound={true}
                isPolicy={true}
                backNavigationURL = "/Documents/smiONE/Policies"
              />
            </div>
          </DynamicCard>
          {loading && <Loader />}
        </div>
      </HomeLayout>
      <CustomAlertModel
        isOpen={showModel}
        onClose={closeCustomAlertModal}
        image={modelImage}
        highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
        HeaderMsg={<p className={`font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none ${kudzuPlusTrue ? "text-white": ""}`}>{headerMsg}</p>}
        subHeaderMsg={<p className={`font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none ${kudzuPlusTrue ? "text-white": ""}`}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        verificationFailure={() => {}}
        footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        showErrorImg={showErrorImg}
        isBorderNone={isBorderNone}
      />
    </>
  );
};

export default withOidcSecure(SMIAgreementCard);
